module.exports = __webpack_public_path__ + "img/781-bb9564.png";